import React, { useState } from 'react'
import { create as ipfsHttpClient } from 'ipfs-http-client'
const ipfs = ipfsHttpClient('https://ipfs.infura.io:5001/api/v0')

export const TextUpload = ({ setUrl }) => {
    const [text, setText] = useState('')
    const [loading, setLoading] = useState(false)
    const [uploaded, setUploaded] = useState(false)
    const [textUrl, setTextUrl] = useState('')

    const uploadText = async (e) => {
        setLoading(true)
        e.preventDefault()

        try {
            const added = await ipfs.add(text)
            const url = `https://ipfs.infura.io/ipfs/${added.path}`
            setTextUrl(url)
            setUrl(url)
            setUploaded(true)
        } catch (err) {
            console.log('Error uploading the file : ', err)
        }
        setLoading(false)
    }

    const uploadButtonLoading = () => {
        if (text === '') return

        if (uploaded) {
            return (
                <h5>
                    ✅{' '}
                    <a href={textUrl} target='_blank' rel='noopener noreferrer'>
                        Text
                    </a>{' '}
                    Uploaded Successfully ✅
                </h5>
            )
        } else {
            if (loading) {
                return (
                    <div className="grid grid-cols-1 gap-y-6 mt-4 sm:grid-cols-3 sm:gap-x-4">
                        <h4>Uploading Text</h4>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                            <div className="bg-blue-600 h-2.5 rounded-full" style="width: 69%"></div>
                        </div>
                        <h4>Please Wait ...</h4>
                    </div>
                )
            } else {
                return <button type='submit' className='inline-flex justify-center py-2 px-4 text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 rounded-md border border-transparent focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 shadow-sm'>Upload Text</button>
            }
        }
    }

    const textForm = () => {
        if (loading || uploaded) {
            return (
                <form>
                    <div className='mb-3'>
                        <label className='block text-sm font-medium text-gray-700'>Enter the Text :</label>
                        <div className='mt-1'>
                        <textarea
                            className='block mt-1 w-full rounded-md border border-gray-300 focus:border-blue-500 focus:ring-blue-500 shadow-sm sm:text-sm'
                            onChange={(e) => setText(e.target.value)}
                            readOnly
                            rows={3}
                        />
                        </div>
                    </div>

                    {uploadButtonLoading()}
                </form>
            )
        } else {
            return (
                <form onSubmit={uploadText}>
                    <div className='mb-3'>
                        <label className='block text-sm font-medium text-gray-700'>Enter the Text :</label>
                        <div className='mt-1'>
                        <textarea
                            className='block mt-1 w-full rounded-md border border-gray-300 focus:border-blue-500 focus:ring-blue-500 shadow-sm sm:text-sm'
                            onChange={(e) => setText(e.target.value)}
                            required
                            rows={3}
                        />
                        </div>
                    </div>

                    {uploadButtonLoading()}
                </form>
            )
        }
    }

    return <div>{textForm()}</div>
}
